module.exports = __webpack_public_path__ + "img/slogan.723111f8.png";